import React from 'react';

import * as nyc from 'ui-library/NYC';
import {StageRunGraph} from 'workflows/visualization/TaggedNodeGraph';

import WorkflowDetailsTable from './components/WorkflowDetailsTable';
import {
  StageConfiguration,
  StageEntryDocument,
  StageEntrySummaryData,
  StageRun,
  StageRunSample,
  Workflow,
  WorkflowStage,
  WorkflowStructuredData,
} from './WorkflowConstants';
import WorkflowDetailsHeader from './WorkflowDetailsHeader';

export interface WorkflowDetailsScreenProps {
  isExpanded: boolean;
  stageIdToStageEntries: {[stageId: string]: Array<StageEntryDocument>};
  stageIdToStageRuns: {[stageId: string]: Array<StageRun>};
  stageIdToStageConfiguration: {[stageId: string]: StageConfiguration};
  stageIdToStructuredData: {[stageId: string]: WorkflowStructuredData};
  stageRunGraph: StageRunGraph;
  stageRunSampleById: {[stageRunSampleId: string]: StageRunSample};
  workflow: Workflow;
  workflowStages: Array<WorkflowStage>;
  entryIdToSummaryData?: {[entryId: string]: StageEntrySummaryData};
}

export default function WorkflowDetailsScreen(props: WorkflowDetailsScreenProps): JSX.Element {
  return (
    <nyc.Container className="expandedContainer--fullScreen" size="lg">
      <WorkflowDetailsHeader
        workflow={props.workflow}
        workflowStages={props.workflowStages}
        stageIdToStageRuns={props.stageIdToStageRuns}
        stageIdToStageConfiguration={props.stageIdToStageConfiguration}
        stageRunGraph={props.stageRunGraph}
        isExpanded={props.isExpanded}
      />
      <nyc.Row fluid={true}>
        <nyc.Col className="u-flex-display u-vertical-flex" lg={22}>
          <WorkflowDetailsTable
            isExpanded={props.isExpanded}
            stageIdToStageEntries={props.stageIdToStageEntries}
            stageIdToStageRuns={props.stageIdToStageRuns}
            stageIdToStageConfiguration={props.stageIdToStageConfiguration}
            stageIdToStructuredData={props.stageIdToStructuredData}
            stageRunGraph={props.stageRunGraph}
            stageRunSampleById={props.stageRunSampleById}
            workflowStages={props.workflowStages}
            workflow={props.workflow}
            isWorkflowEditable={props.workflow.permissions.writable}
            entryIdToSummaryData={props.entryIdToSummaryData}
          />
        </nyc.Col>
      </nyc.Row>
    </nyc.Container>
  );
}
